/*
 * @Author: Zhongnanwei
 * @Date: 2021-08-11 18:01:12
 * @LastEditors: Zhongnanwei
 * @LastEditTime: 2021-11-03 13:45:19
 * @Description: 
 */
const img1 = require(`../assets/pc/application-1.png`)
const img2 = require(`../assets/pc/application-2.png`)
const img3 = require(`../assets/pc/application-3.png`)
const img4 = require(`../assets/pc/application-4.png`)

export default {
  applications: [
    {
      img: img1,
      title: '局控端',
      content: [
        '支持教育管理部门的统筹规划、实时监管，构建三位一体（局-校-机构）的管理和服务模式',
        '可视化呈现本区域学校、机构、课程、经费等数据信息，实现数据辅助科学决策'
      ],
      tags: [
        '数据决策',
        '资质审核',
        '课程审核',
        '服务管理',
        '服务评价',
        '收费监管'
      ]
    },
    {
      img: img2,
      title: '学校端',
      content: [
        '平台采用人工智能和大数据分析技术，根据学校的育人目标及办学特色，参照课程目标，匹配该校办学理念的课程，做到供学校自主选择调配，形成特色化、序列性、发展型的学校课后服务课程体系'
      ],
      tags: [
        '课程管理',
        '分班设置',
        '报名设置',
        '开班设置',
        '请假考勤',
        '午休订餐'
      ]
    },
    {
      img: img3,
      title: '家长端',
      content: [
        '家长可以对课程、老师及校内服务进行评价，信息直达教育主管部门进行监督',
        '课堂表现实时推送家长微信端，进行有效督导，与孩子成长保持同步',
        '家长可在学校平台进行课堂订购及退费操作，免去繁琐跑腿过程'
      ],
      tags: ['课程订购', '开课通知', '请假考勤', '午休订餐', '服务评价']
    },
    {
      img: img4,
      title: '第三方教培机构端',
      content: [
        '平台根据累计的海量的学校报课、学生上课、家长反馈的数据，给机构经营发展提供最优和最科学的数据支撑，为机构赋能'
      ],
      tags: ['课班管理', '互动管理', '服务评价', '结算中心', '考勤打卡']
    }
  ],
  userType: [
    {
      value: 1,
      label: '教育主管部门'
    },
    {
      value: 2,
      label: "系统集成商"
    },
    {
      value: 3,
      label: '培训机构'
    },
    {
      value: 4,
      label: '学校'
    }
  ]
}